/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface UploadTask
 */
export interface UploadTask {
  /**
   *
   * @type {string}
   * @memberof UploadTask
   */
  readonly uuid?: string;
  /**
   *
   * @type {Date}
   * @memberof UploadTask
   */
  readonly created?: Date;
  /**
   *
   * @type {Date}
   * @memberof UploadTask
   */
  readonly updated?: Date;
  /**
   *
   * @type {UploadTaskBroDomainEnum}
   * @memberof UploadTask
   */
  broDomain?: UploadTaskBroDomainEnum;
  /**
   *
   * @type {string}
   * @memberof UploadTask
   */
  projectNumber: string;
  /**
   *
   * @type {UploadTaskRegistrationTypeEnum}
   * @memberof UploadTask
   */
  registrationType: UploadTaskRegistrationTypeEnum;
  /**
   *
   * @type {UploadTaskRequestTypeEnum}
   * @memberof UploadTask
   */
  requestType: UploadTaskRequestTypeEnum;
  /**
   *
   * @type {object}
   * @memberof UploadTask
   */
  metadata?: object;
  /**
   *
   * @type {object}
   * @memberof UploadTask
   */
  sourcedocumentData?: object;
  /**
   *
   * @type {UploadTaskStatusEnum}
   * @memberof UploadTask
   */
  status?: UploadTaskStatusEnum;
  /**
   *
   * @type {string}
   * @memberof UploadTask
   */
  log?: string;
  /**
   *
   * @type {string}
   * @memberof UploadTask
   */
  broErrors?: string;
  /**
   *
   * @type {number}
   * @memberof UploadTask
   */
  progress?: number | null;
  /**
   *
   * @type {string}
   * @memberof UploadTask
   */
  broId?: string | null;
  /**
   *
   * @type {string}
   * @memberof UploadTask
   */
  broDeliveryUrl?: string | null;
  /**
   *
   * @type {string}
   * @memberof UploadTask
   */
  readonly dataOwner?: string | null;
}

/**
 * @export
 */
export const UploadTaskBroDomainEnum = {
  Gmn: "GMN",
  Gmw: "GMW",
  Gld: "GLD",
  Frd: "FRD",
  Gar: "GAR",
  Cpt: "CPT",
  Bhr: "BHR",
  Guf: "GUF",
  Gpd: "GPD",
} as const;
export type UploadTaskBroDomainEnum =
  (typeof UploadTaskBroDomainEnum)[keyof typeof UploadTaskBroDomainEnum];

/**
 * @export
 */
export const UploadTaskRegistrationTypeEnum = {
  GmnStartRegistration: "GMN_StartRegistration",
  GmnMeasuringPoint: "GMN_MeasuringPoint",
  GmnMeasuringPointEndDate: "GMN_MeasuringPointEndDate",
  GmnTubeReference: "GMN_TubeReference",
  GmnClosure: "GMN_Closure",
  GmwConstruction: "GMW_Construction",
  GmwElectrodeStatus: "GMW_ElectrodeStatus",
  GmwGroundLevel: "GMW_GroundLevel",
  GmwGroundLevelMeasuring: "GMW_GroundLevelMeasuring",
  GmwInsertion: "GMW_Insertion",
  GmwLengthening: "GMW_Lengthening",
  GmwShortening: "GMW_Shortening",
  GmwPositions: "GMW_Positions",
  GmwPositionsMeasuring: "GMW_PositionsMeasuring",
  GmwShift: "GMW_Shift",
  GmwMaintainer: "GMW_Maintainer",
  GmwOwner: "GMW_Owner",
  GmwRemoval: "GMW_Removal",
  GmwSubsequentAdditionalSurvey: "GMW_SubsequentAdditionalSurvey",
  GmwTubeStatus: "GMW_TubeStatus",
  GmwWellHeadProtector: "GMW_WellHeadProtector",
  Gar: "GAR",
  GldStartRegistration: "GLD_StartRegistration",
  GldAddition: "GLD_Addition",
  GldClosure: "GLD_Closure",
  FrdStartRegistration: "FRD_StartRegistration",
  FrdGemMeasurementConfiguration: "FRD_GEM_MeasurementConfiguration",
  FrdGemMeasurement: "FRD_GEM_Measurement",
  FrdEmmInstrumentConfiguration: "FRD_EMM_InstrumentConfiguration",
  FrdEmmMeasurement: "FRD_EMM_Measurement",
  FrdClosure: "FRD_Closure",
  Cpt: "CPT",
  BhrP: "BHR-P",
  BhrG: "BHR-G",
  BhrGt: "BHR-GT",
  Sfr: "SFR",
  GufStartRegistration: "GUF_StartRegistration",
  GufNewLicense: "GUF_NewLicense",
  GufExpandedRealisedInstallation: "GUF_ExpandedRealisedInstallation",
  GufWellFunction: "GUF_WellFunction",
  GufHeight: "GUF_Height",
  GufClosure: "GUF_Closure",
  GufAddRealisedInstallation: "GUF_AddRealisedInstallation",
  GufClosureRealisedPart: "GUF_ClosureRealisedPart",
  GpdStartRegistration: "GPD_StartRegistration",
  GpdAddReport: "GPD_AddReport",
  GpdEndRegistration: "GPD_EndRegistration",
} as const;
export type UploadTaskRegistrationTypeEnum =
  (typeof UploadTaskRegistrationTypeEnum)[keyof typeof UploadTaskRegistrationTypeEnum];

/**
 * @export
 */
export const UploadTaskRequestTypeEnum = {
  Registration: "registration",
  Replace: "replace",
  Move: "move",
  Insert: "insert",
  Delete: "delete",
} as const;
export type UploadTaskRequestTypeEnum =
  (typeof UploadTaskRequestTypeEnum)[keyof typeof UploadTaskRequestTypeEnum];

/**
 * @export
 */
export const UploadTaskStatusEnum = {
  Pending: "PENDING",
  Processing: "PROCESSING",
  Completed: "COMPLETED",
  Failed: "FAILED",
  Unfinished: "UNFINISHED",
} as const;
export type UploadTaskStatusEnum = (typeof UploadTaskStatusEnum)[keyof typeof UploadTaskStatusEnum];

/**
 * Check if a given object implements the UploadTask interface.
 */
export function instanceOfUploadTask(value: object): value is UploadTask {
  if (
    (!("projectNumber" in (value as Record<string, any>)) &&
      !("project_number" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["projectNumber"] === undefined &&
      (value as Record<string, any>)["project_number"] === undefined)
  )
    return false;
  if (
    (!("registrationType" in (value as Record<string, any>)) &&
      !("registration_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["registrationType"] === undefined &&
      (value as Record<string, any>)["registration_type"] === undefined)
  )
    return false;
  if (
    (!("requestType" in (value as Record<string, any>)) &&
      !("request_type" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["requestType"] === undefined &&
      (value as Record<string, any>)["request_type"] === undefined)
  )
    return false;
  return true;
}

export function UploadTaskFromJSON(json: any): UploadTask {
  return UploadTaskFromJSONTyped(json, false);
}

export function UploadTaskFromJSONTyped(json: any, ignoreDiscriminator: boolean): UploadTask {
  if (json == null) {
    return json;
  }
  return {
    uuid: json["uuid"] == null ? undefined : json["uuid"],
    created: json["created"] == null ? undefined : new Date(json["created"]),
    updated: json["updated"] == null ? undefined : new Date(json["updated"]),
    broDomain: json["bro_domain"] == null ? undefined : json["bro_domain"],
    projectNumber: json["project_number"],
    registrationType: json["registration_type"],
    requestType: json["request_type"],
    metadata: json["metadata"] == null ? undefined : json["metadata"],
    sourcedocumentData:
      json["sourcedocument_data"] == null ? undefined : json["sourcedocument_data"],
    status: json["status"] == null ? undefined : json["status"],
    log: json["log"] == null ? undefined : json["log"],
    broErrors: json["bro_errors"] == null ? undefined : json["bro_errors"],
    progress:
      json["progress"] === undefined
        ? undefined
        : json["progress"] === null
        ? null
        : json["progress"],
    broId:
      json["bro_id"] === undefined ? undefined : json["bro_id"] === null ? null : json["bro_id"],
    broDeliveryUrl:
      json["bro_delivery_url"] === undefined
        ? undefined
        : json["bro_delivery_url"] === null
        ? null
        : json["bro_delivery_url"],
    dataOwner:
      json["data_owner"] === undefined
        ? undefined
        : json["data_owner"] === null
        ? null
        : json["data_owner"],
  };
}

export function UploadTaskToJSON(json: any): UploadTask {
  return UploadTaskToJSONTyped(json, false);
}

export function UploadTaskToJSONTyped(
  value?: Omit<UploadTask, "uuid" | "created" | "updated" | "data_owner"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    bro_domain: value["broDomain"],
    project_number: value["projectNumber"],
    registration_type: value["registrationType"],
    request_type: value["requestType"],
    metadata: value["metadata"],
    sourcedocument_data: value["sourcedocumentData"],
    status: value["status"],
    log: value["log"],
    bro_errors: value["broErrors"],
    progress: value["progress"],
    bro_id: value["broId"],
    bro_delivery_url: value["broDeliveryUrl"],
  };
}
